import React from 'react';

export const Logo = () => (
    <div className="form-logo">Logo EasySend</div>
);
